export const formatMenuData = (rows) => {
  try {
    var topNode = {};
    var topNodeMap = new Map();

    for (var rowNum = 0; rowNum < rows.length; rowNum++) {
      //if row is missing required fields, skip
      if (!validateRow(rows[rowNum])) {
        continue;
      }

      try {
        //Retrieve Top Node
        var currentHeader1 = rows[rowNum].header1;
        if (topNodeMap.has(currentHeader1)) {
          topNode = topNodeMap.get(currentHeader1);
        } else {
          topNode = createNode();
          topNode.title = currentHeader1;
          topNode.style = "header1";
          topNodeMap.set(currentHeader1, topNode);
        }

        var currentNode = topNode;
        //do recursive loop times on the title to find the last node that matches
        //TODO: currently ending at column 4 since we have 4 header columns
        var subHeaders = [
          rows[rowNum].header2,
          rows[rowNum].header3,
          rows[rowNum].header4,
        ];
        for (
          var headerColNum = 0;
          headerColNum < subHeaders.length;
          headerColNum++
        ) {
          var columnTitle = subHeaders[headerColNum];
          //find the last node based on title (only handle non null/non empty titles)
          if (
            columnTitle !== undefined &&
            columnTitle !== null &&
            columnTitle.toString().trim().length > 0
          ) {
            currentNode = findNode(currentNode, columnTitle, headerColNum);
          }
        }

        //add item to current node
        var item = {};
        item.name = rows[rowNum].name;
        item.description = rows[rowNum].description;
        item.vintage = rows[rowNum].vintage;
        item.price = rows[rowNum].price;
        item.format = rows[rowNum].format;
        item.priceUnit = rows[rowNum].priceUnit;
        item.imageUrl = rows[rowNum].imageUrl;
        currentNode.items.push(item);

        //since topNode's child nodes might be updated, repush into Map
        topNodeMap.delete(topNode.title);
        topNodeMap.set(topNode.title, topNode);
      } catch (e) {
        console.error(e);
        //console.log("Row cannot be processed: " + rows[rowNum]);
      }
    }

    //turn Map into proper json
    //we don't want map keys as "propertyKey" in the JSON, hence calling custom parser that just turns Map values into arrays
    var list = [];
    list = convertMapToJon(list, topNodeMap);
    return list;
  } catch (e) {
    console.log(e);
    return [];
  }
};

/**
 * Validation of required fields for a given row/item in spreadsheet
 *
 * @param {array} row
 */
function validateRow(row) {
  if (
    row.header1 === undefined ||
    row.name === undefined ||
    row.price === undefined
  ) {
    return false;
  } else {
    return true;
  }
}

/**
 * Helper method to create a Node section representing a list section
 */
function createNode() {
  var node = {
    title: "",
    style: "",
    section: [],
    childKeys: new Map(),
    items: [],
  };
  return node;
}

/**
 * Helper method to determine Node's style property based on Header column location in spreadsheet
 *
 * @param {number} headerNum
 */
function getHeaderStyle(headerNum) {
  //TODO: Could improve how to determine header style based on naming of property
  if (headerNum === 0) {
    return "header2";
  } else if (headerNum === 1) {
    return "header3";
  } else if (headerNum === 2) {
    return "header4";
  }
}

/**
 * Recursive function to find nested tree nodes
 * @param {node} currentNode
 * @param {string} title
 * @param {number} headerNum
 */
function findNode(currentNode, title, headerNum) {
  var section;
  if (currentNode.childKeys.has(title)) {
    section = currentNode.childKeys.get(title);
    return section;
  } else {
    section = createNode();
    section.title = title;
    section.style = getHeaderStyle(headerNum);
    currentNode.childKeys.set(title, section);
    return section;
  }
}

/**
 * Custom JSON converter since we have custom Map keys/values data
 * @param {Array} list
 * @param {Map} map
 */
function convertMapToJon(list, map) {
  if (map === undefined) {
    return null;
  }
  map.forEach((value, key) => {
    var node = {};
    node.title = value.title;
    node.style = value.style;

    //Section might have its own items and additional subsection(s)
    //If section has its own items, set the node's items list
    if (value.items !== undefined && value.items.length > 0) {
      node.items = value.items;
    }

    if (value.childKeys === undefined || value.childKeys.size === 0) {
      node.items = value.items;
    } else {
      //if there are child sections, build sub section
      var items = [];
      node.section = convertMapToJon(items, value.childKeys);
    }
    list.push(node);
  });
  return list;
}

/**
 * Helper method to print out excel records for debugging
 * @param {Array of strings} row
 */

// eslint-disable-next-line
function printLine(row) {
  console.log(
    "HEADER1 : " +
      row.header1 +
      ", HEADER2 : " +
      row.header2 +
      ", HEADER3 : " +
      row.header3 +
      ", HEADER4 : " +
      row.header4 +
      ", WINETYPE : " +
      row.wineType +
      ", REGION : " +
      row.region +
      ", SUBREGION :  " +
      row.subRegion +
      ", GRAPE : " +
      row.grape +
      ", NAME :  " +
      row.name +
      ", DESCRIPTION :  " +
      row.description +
      ", VINTAGE : " +
      row.vintage +
      ", PRICE :  " +
      row.price +
      ", FORMAT :  " +
      row.format +
      ", PRICEUNIT :  " +
      row.priceUnit
  );
}

/**
 * Helper function to get publish menus
 */
export const getPublishedMenus = (menus) =>
  menus.filter((menu) => menu?.isPublished === true);

/**
 * Helper function sortMenu
 * Sorted menus by the menusPosition object
 */
export const sortMenus = (menus, menusPosition = []) => {
  const orderMenus = menus.map((menu) => {
    let order = menusPosition.findIndex((menuId) => menuId === menu.id);

    // If can not find menu in "menuPositions", set this menu to last position
    if (order === -1) {
      order = menus.length;
    }

    return { ...menu, order };
  });

  orderMenus.sort((el1, el2) => el1.order - el2.order);

  return orderMenus;
};

/**
 * Helper function to update fonts and color styles for text
 * @param {string} field
 */
export const updateTextStyles = (field) => {
  return {
    ...(field?.font && { fontFamily: field?.font }),
    ...(field?.color && { color: field?.color }),
    ...(field?.textstyle &&
      field?.textstyle.includes("bold") && { fontWeight: "bold" }),
    ...(field?.textstyle &&
      field?.textstyle.includes("italic") && { fontStyle: "italic" }),
  };
};

export const checkingMatchColor = (colorName, color) => {
  const compareColor = color.toLowerCase().replace(/ /g, "");

  switch (colorName) {
    case "white": {
      return (
        compareColor === "#fff" ||
        compareColor === "#ffffff" ||
        compareColor === "rgb(255,255,255)" ||
        compareColor === "white"
      );
    }

    case "black": {
      return (
        compareColor === "#000" ||
        compareColor === "#000000" ||
        compareColor === "rgb(0,0,0)" ||
        compareColor === "black"
      );
    }
    case "tomato": {
      return compareColor === "#7b2133" || compareColor === "rgb(123,33,51)";
    }

    case "gray": {
      return compareColor === "#6c757d" || compareColor === "rgb(108,117,125)";
    }

    default:
      return false;
  }
};

export const checkingWCAGConformanceSetting = (
  setting,
  settingType = "restaurant",
  settingKey = ""
) => {
  //Existing list might not have any settings
  if (!setting) return true;

  // Checking was user updated the font of setting or not
  const defaultFont = "Libre Baskerville";
  const { font, color, textstyle } = setting;

  /**
   * Checking with restaurant setting
   */
  if (settingType === "restaurant") {
    if (
      font !== defaultFont ||
      !checkingMatchColor("white", color) ||
      textstyle.length
    ) {
      return false;
    }

    return true;
  }

  /**
   * Checking with menu setting
   */
  if (settingKey) {
    // Special case for "headerOne"
    if (settingKey === "headerOne") {
      if (
        font !== defaultFont ||
        !checkingMatchColor("tomato", color) ||
        textstyle.length
      ) {
        return false;
      }

      return true;
    }

    // Special case for "subtext"
    if (settingKey === "subtext") {
      if (
        font !== defaultFont ||
        !checkingMatchColor("gray", color) ||
        textstyle.length
      ) {
        return false;
      }

      return true;
    }
  }

  // Normal cases for remaining types
  if (
    font !== defaultFont ||
    !checkingMatchColor("black", color) ||
    textstyle.length
  ) {
    return false;
  }

  return true;
};

/**
 * Helper function checking is menu setting pass WVAG Conformance
 * @param {object} settingObj
 * @return boolean
 */
export const checkingWCAGConformance = (settingObj) => {
  // Checking was user updated the background or not
  if (settingObj.backgroundImageUrl) {
    return false;
  }

  /**
   * Checking the restaurant setting
   */
  const { dateText, descriptionText, restaurantName } = settingObj;
  if (
    !checkingWCAGConformanceSetting(dateText) ||
    !checkingWCAGConformanceSetting(descriptionText) ||
    !checkingWCAGConformanceSetting(restaurantName)
  ) {
    return false;
  }

  /**
   * If user don't made any change on restaurant setting
   * => Continue checking menus setting
   */
  const { menus } = settingObj;

  if (menus) {
    // Checking was user updated the menu setting or not
    for (let i = 0, { length } = menus; i < length; i++) {
      const menu = menus[i];
      if (
        !checkingWCAGConformanceSetting(menu.headerOne, "menu", "headerOne") ||
        !checkingWCAGConformanceSetting(menu.headerTwo, "menu") ||
        !checkingWCAGConformanceSetting(menu.headerThree, "menu") ||
        !checkingWCAGConformanceSetting(menu.headerFour, "menu") ||
        !checkingWCAGConformanceSetting(menu.normalText, "menu") ||
        !checkingWCAGConformanceSetting(menu.subtext, "menu", "subtext")
      ) {
        return false;
      }
    }
  }

  /**
   * If user don't change background image and don't change restaurant, menu setting
   * => Pass WCAG Conformance
   */
  return true;
};
